export const A4_WIDTH = 816;
export const A4_HEIGHT = 1056;
export const PDF_A4_WIDTH = 595.28;

export const CANVAS_CONFIG = {
  width: A4_WIDTH,
  height: A4_HEIGHT,
  backgroundColor: "white",
  fontFamily: "Arial, sans-serif",
  fontSize: 14,
  lineHeight: 1.6,
  padding: 40,
};

export const WORD_LINES_PER_PAGE = 45;
export const WORD_LINE_HEIGHT = 20;
